import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1AADA0',
    },
    secondary: {
      main: '#1AADA0',
    },
    // メイン画面の背景
    background: {
      default: '#F1F9F9',
    },
  },
  typography: {
    fontFamily: 'Meiryo',
  },
  overrides: {
    MuiIconButton: {
      root: {
        '&:focus': {
          boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.1), 0px 6px 10px 0px rgba(0, 0, 0, 0.07), 0px 1px 18px 0px rgba(0, 0, 0, 0.06)',
        },
      },
    },
    // ボタン
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: '2rem',
        height: '2.5rem',
        minWidth: '10.5rem',
        border: '1px solid transparent',
        boxShadow: 'none',
        // 第三のボタン用のカスタムスタイル
        // メニュー用
        '&.mainButton': {
          color: '#ffffff',
          borderRadius: '10px',
          '&:hover': {
          },
        },
        // サブメニュー用
        '&.subButton': {
          color: '#ffffff',
          borderRadius: '10px',
        },
        // ユーザーメニュー用
        '&.userButton': {
          color: '#1AADA0',
          padding: '2px 0',
          width: '110px',
          borderRadius: '10px',
        },
        '&.tertiary': {
          backgroundColor: '#ffffff',
          borderColor: '#1AADA0',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#ffffff', // hover時の色を変えない
          },
          '& .MuiButton-endIcon': {
            color: '#1AADA0',
          },
        },
        // キャンセルボタン
        '&.cancel': {
          backgroundColor: '#9c9c9c',
          borderColor: '#9c9c9c',
          color: '#ffffff',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#9c9c9c', // hover時の色を変えない
          },
        },
        // ダイアログのプラスマイナスボタン
        '&.addDelete': {
          backgroundColor: '#ffffff',
          borderColor: '#D3AD45',
          color: '#D3AD45',
          boxShadow: 'none',
          padding: '1px 7px',
          fontSize: '14px',
          minWidth: 'unset',
          height: 'unset',
          '&:hover': {
            backgroundColor: '#ffffff', // hover時の色を変えない
          },
        },
        '&.classification': {
          backgroundColor: '#ffffff',
          border: '2px solid',
          borderRadius: '32px',
          height: '40px',
          color: '#000000',
          boxShadow: 'none',
          minWidth: 'auto',
        },
        '&.addAll': {
          backgroundColor: '#ffffff',
          borderColor: '#D3AD45',
          color: '#D3AD45',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#ffffff', // hover時の色を変えない
          },
        },
      },
      containedPrimary: {
        backgroundColor: '#ffffff',
        borderColor: '#1AADA0',
        color: '#1AADA0',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: '#ffffff', // hover時の色を変えない
        },
      },
      containedSecondary: {
        backgroundColor: '#D3AD45',
        color: '#ffffff',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: '#D3AD45', // hover時の色を変えない
        },
      },
    },
    // チェックボックス
    MuiCheckbox: {
      root: {
        color: '#1AADA0',
        transform: 'scale(1.5)',
        marginRight: '0.4rem',
        '&.Mui-checked': {
          color: '#1AADA0 !important',
        },
      },
    },
    // ラジオボタン
    MuiRadio: {
      root: {
        color: '#1AADA0',
        transform: 'scale(1.2)',
        marginRight: '0.4rem',
        '&.Mui-checked': {
          color: '#1AADA0 !important',
        },
        '& input:focus': {
          outline: '2px solid red',
          outlineOffset: '2px',
        },
      },
    },
    // タブ
    MuiTabs: {
      root: {
        color: '#00BCCC',
      },
      indicator: {
        display: 'none',
      },
    },
    MuiTab: {
      root: {
        borderRadius: '1rem 1rem 0 0',
        color: '#00CBBB !important', // 非選択時の文字色
        backgroundColor: '#BFEAEB', // 非選択時の背景色
        fontSize: '1rem',
        fontWeight: 'bold',
        marginRight: '0.5rem',
        opacity: '1.0 !important',
        '&$selected': {
          color: '#ffffff !important', // 選択時の文字色
          backgroundColor: '#00CBBB', // 選択時の背景色
          position: 'relative',
          zIndex: 1,
          // TODO 選択時の逆三角形
          '&::after': {
            content: "''",
            position: 'absolute',
            bottom: '-10px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid #00BCCC',
            zIndex: 2,
          },
        },
      },
    },
    // テキストフィールド
    MuiInputBase: {
      root: {
        backgroundColor: '#ffffff',
        '&.Mui-error .MuiInput-input': {
          backgroundColor: '#ffd7d7',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: '#ffffff',
        '&.Mui-error': {
          backgroundColor: '#ffd7d7',
        },
      },
      input: {
        '&$error': {
          backgroundColor: '#ffd7d7',
        },
      },
    },
    // ダイアログ
    MuiDialog: {
      paper: {
        borderRadius: '1rem',
      },
    },
    // ダイアログタイトル
    MuiDialogTitle: {
      root: {
        padding: '0',
      },
    },
    MuiTypography: {
      h6: {
        fontWeight: 'bold !important',
      },
    },
    // テーブル
    MuiTable: {
      root: {
      },
    },
    MuiTableCell: {
      root: {
        padding: '0',
      },
      head: {
        backgroundColor: '#00CBBB',
      },
      body: {
      },
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
          backgroundColor: '#FBFBFB',
        },
      },
    },
    // セレクト
    MuiSelect: {
      select: {
        minWidth: '180px',
        maxWidth: '180px',
        padding: '0.3rem',
        fontSize: '0.875rem',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '0.875rem',
      },
    },
    //  topボタン
    MuiFab: {
      root: {
        backgroundColor: '#FFFFFF',
        position: 'fixed',
        paddingBottom: '12px',
        right: '40px',
        bottom: '40px',
        transform: 'scale(1) !important',
        visibility: 'visible !important',
        fontSize: '1rem',
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.05), 0px 6px 10px 0px rgba(0, 0, 0, 0.035), 0px 1px 18px 0px rgba(0, 0, 0, 0.03)',
      },
      label: {
        display: 'inline',
        lineHeight: '6px',
        color: '#00CBBB',
        marginTop: '-8px',
      },
    },
    // ページング(※矢印ボタンは各cssで定義)
    MuiPaginationItem: {
      root: {
        margin: '0 6px',
        minWidth: '20px',
        width: '32px',
        fontWeight: '550',
      },
      outlined: {
        '&.Mui-selected': {
          border: '1px solid #D3AD45',
        },
        '&:hover': {
          border: '1px solid #D3AD45',
        },
      },
      page: {
        '&.Mui-selected': {
          backgroundColor: ' #FFEFC3',
          '&:hover': {
            backgroundColor: ' #FFEFC3 !important',
          },
        },
        '&:hover': {
          backgroundColor: ' #FFEFC3',
        },
      },
    },
    // スライダー
    MuiSlider: {
      markLabel: {
        color: '#1AADA0 !important',
      },
    },
  },
  props: {
    MuiCheckbox: {
      disableRipple: true,
    },
    MuiRadio: {
      disableRipple: true,
    },
    MuiButton: {
      disableRipple: true,
    },
    MuiIconButton: {
      disableRipple: true,
    },
  },
});

export default theme;
